<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <div class="text-center text-white py-1" v-if="!checkModuleAccess2(constAccessType.edit)">
                <div class="d-flex align-items-center" style="height: calc(100vh - 50px);">
                    {{getLanguage['O']['SUB']}}<br />
                    {{getLanguage['O']['SUB2']}}
                </div>
            </div>
            <div v-else-if="checkModuleAccess2(constAccessType.edit)">
                <CRow class="align-items-center  my-2" v-if="!bool_isAMV">
                    <div class="col-12">
                        <div style="background: #1c1c20; color: #fff; padding: 10px; border-radius: .25rem; border: 1px solid rgba(249, 249, 249, 0.28);position:relative">
                            <span v-html='String.format(this.getLanguage["GGE"]["WA"])'></span>
                            <h3 class="font-weight-bold mb-0" :class="walletColor">{{this.CurrencySymbol}} {{this.creditBalance}}</h3>
                            ≈ USDT {{ formatNumber((this.creditBalance / this.exchangeRate), 9) }}

                            <a to="/W/WDU" tag="a" class="" style="position: absolute; bottom: 10px; right: 10px;" @click="addWithdrawal">
                                <CButton class='font-weight-bold m-0 mt-2 p-1' color="success"><span>{{this.getLanguage['SMB']['W']}}</span></CButton>
                            </a>
                        </div>
                    </div>
                </CRow>

                <CRow class="align-items-center  my-1">
                    <div class="col-12 d-flex ">
                        <div class="quicklink position-relative">
                            <a href="#" :class="bool_isAMV ? '':'active' " @click="bool_isAMV = false">
                                {{this.getLanguage['MEM']['TRANS']}}
                            </a>
                            <a href="#" :class="bool_isAMV ? 'active':'' " v-if="getUserInfo.AT == 4" @click="addWithdrawal">
                                {{this.getLanguage['SMB']['W']}}
                            </a>

                            <!--<div class="float-right" @click="addWithdrawal" v-if="getUserInfo.AT == 4" style="margin-top:-2px;color: #fff; font-size: 1.25rem; position: absolute; right: 30px; top: 50%; transform: translate(0%, -50%); ">
        <img class="img-fluid" width="18" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set2/WITHDRAW.svg">
    </div>-->
                            <img class="img-fluid float-right" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_earth-19.svg" width="20" style="position: absolute; right: 0; top: 50%; transform: translate(0%, -50%); " @click="slideinsearchfilter ? slideinsearchfilter = false:slideinsearchfilter = true" v-if="!bool_isAMV">
                        </div>
                    </div>
                </CRow>

                <CRow v-if="!bool_isAMV">
                    <CCol col="12">
                        <div class="record-header">
                            <div class="">
                                {{getLanguage['MTA']['TID']}} /  {{getLanguage['GL']['DT']}}
                                <!--<i :class="setSortLogo('AGN')" class="sortlogo"></i>-->
                            </div>
                            <div class="text-right">
                                {{getLanguage['MEM']['A']}} / {{this.getLanguage["MEM"]["CKMS"]}}
                                <!--<i :class="setSortLogo('CBL')" class="sortlogo"></i>-->
                            </div>
                        </div>
                        <div class="nodata-record" v-if="arr_transactionreportList.length == 0">
                            <div>
                                <img class="img-fluid" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_norecord.svg" width="125">
                                <span class="d-block" style="margin-top: -17px;"> {{this.getLanguage['GL']['NR']}}</span>
                            </div>
                        </div>
                        <div class="record-item" v-for="(data,index) in arr_transactionreportList" @click="slideInMemberDetail(data)">
                            <div>
                                <div class="font-weight-bold text-white">{{data.AGTI}}</div>
                                <div class="record-desc">
                                    <template v-if="data.UTS">
                                        {{data.UTS | moment('DD MMM YYYY HH:mm:ss')}}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </div>
                            </div>
                            <div class="text-right">
                                <!--<div class="" :class="data.RS == 2 ? 'text-success' : (data.RS == 3 ? 'text-danger' : '')">{{ formatNumber(data.TA, 2, data.CS) }}</div>
                                <div class="record-desc" :class="data.RS == 2 ? 'text-success' : (data.RS == 3 ? 'text-danger' : 'text-warning')">{{renderStatus(data.RS)}}</div>-->

                                <div class="data.RS==2 ? 'text-success' :''"> <span v-if="data.RS==2 && data.TT==2">- </span>{{ formatNumber(data.TA, 2, data.CS) }}</div>
                                <div class="record-desc">{{renderStatus(data.RS)}}</div>
                            </div>
                        </div>
                    </CCol>
                </CRow>

                <div class="inputform" v-if="bool_isAMV">
                    <div class="position-relative h-100 overflow-auto">
                        <div class="form-section mt-0">
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{getLanguage['CRYPTO']['CN']}} & {{getLanguage['CRYPTO']['N']}} <span class="required" /></div>
                                <div class="sliding-item-desc">
                                    <treeselect :multiple="false"
                                                @input="CryptoChange"
                                                :options="dd_crypto"
                                                v-model="obj_aw['BAI']"
                                                :placeholder="getLanguage['CRYPTO']['CN'] + ' & ' + getLanguage['CRYPTO']['N']"
                                                :max-height="250"
                                                :disabled="obj_aw.I > 0"
                                                ref="BAI">
                                        <label class="d-flex align-items-center" slot="option-label" slot-scope="{ node }" v-html="node.label"></label>
                                        <label class="d-flex align-items-center" slot="value-label" slot-scope="{ node }" v-html="node.label"></label>
                                    </treeselect>
                                    <span class="ErrMsg">{{ ValidationErrMsg('BAI','CN') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{getLanguage['MTA']['WRA']}} <span class="required" /></div>
                                <div class="sliding-item-desc">
                                    <CInput size="sm"
                                            vertical
                                            v-model="obj_aw['ABN']"
                                            :placeholder="this.getLanguage['MTA']['WRA']"
                                            :value="obj_aw.ABN"
                                            @change="v => obj_aw.ABN = v"
                                            :disabled="!obj_aw['BAI']"
                                            ref="ABN"></CInput>
                                    <span class="ErrMsg">{{ ValidationErrMsg('ABN','WRA') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">
                                    {{this.getLanguage["MEM"]["WA"]}}<span class="required" /> <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                    <!--<span class="remarkNote"> ({{getLanguage["MTA"]["AWRA"]}} :  {{formatNumber(this.creditBalance, 2, this.CurrencySymbol)}})</span>-->
                                </div>
                                <div class="sliding-item-desc">
                                    <CInput type="number" placeholder="0" size="sm" v-model="obj_aw.TA" ref="TA" :disabled="!obj_aw['BAI'] || (creditBalance).includes('-')">
                                        <template #prepend v-if="CurrencySymbol">
                                            <CButton size="sm"
                                                     type="button"
                                                     color="primary"
                                                     style="min-width: auto; z-index: 0;">
                                                {{CurrencySymbol}}
                                            </CButton>
                                        </template>
                                        <template #append>
                                            <CButton size="sm"
                                                     type="button"
                                                     color="primary"
                                                     @click="obj_aw['BAI'] ? (obj_aw.TA = creditBalance) : ''"
                                                     style=" min-width: 40px; z-index: 0; border: none !important;" :style="!obj_aw['BAI'] ? 'background: #2b2929 !important;opacity: .6 !important;' : 'background: #25282d !important'">
                                                {{getLanguage["PM"]["MAX1"]}}
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ ValidationErrMsg('TA','TA') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-section">
                            {{getLanguage['DCUZ']['NOTE']}} : <br />
                            <!--{{getLanguage["MTA"]["DRLIMIT"]}}  <span class="text-white ml-2"> {{ (obj_aw.minw > 0) ? obj_aw.minw : 0 }} / USDT {{ (obj_aw.minw > 0) ? obj_aw.minw : 0 }} </span>-->

                            <div class="btngroup" style=" display: flex; gap: 10px; width: 100%; align-items: center; margin-top: 30px;">
                                <div style="width: 100%; line-height: 12px;">
                                    {{getLanguage["MTA"]["AMTR"]}} <br />
                                    <h4 class="text-white mb-0">USDT {{ (obj_aw.CWA > 0) ? obj_aw.CWA : (0).toFixed(getThousandCurrency ? 3 : 2)}}</h4>
                                </div>
                                <CButton block color="success" class='font-weight-bold m-0' @shortkey="saveWithdraw()" @click="saveWithdraw()"><span>{{this.getLanguage['SMB']['W']}}</span></CButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div :class="slideinsearchfilter || slideindetail ? 'slideinoverlay': ''" @click="slideindetail= false;slideinsearchfilter = false;"></div>
                <div class="sliding-div" :class="{ 'is-visible': slideinsearchfilter }" @click.stop style="height:85%">
                    <div class="position-relative h-100 overflow-auto">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="searchExcludeSubAgent" id="searchExcludeSubAgent" />
                                        <label class="searchLabel ml-1" for="searchExcludeSubAgent">{{getLanguage["GL"]["ODA"]}}</label>
                                    </div>
                                </div>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  :limitText="count => `+${count}`"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :load-options="loadAgentOptions"
                                                  :options="ddAgentList"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :disable-branch-nodes="false"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol' v-if="showSubBrand">
                                <span class='searchLabel'>{{getLanguage['GL']['D']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent"
                                            openDirection="below"
                                            :isDisabled="searchExcludeSubAgent"
                                            @input="selectSubAgentOptions" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>

                        <div class="btngroup">
                            <CButton block color="secondary" class='font-weight-bold m-0' @click="searchExcludeSubAgent = false;searchAgent = null;searchSubAgent = null;clearDateRangeFilter()"><span>{{this.getLanguage['BTN']['RS']}}</span></CButton>
                            <CButton block color="success" class='font-weight-bold m-0' @shortkey="newSearch()" @click="newSearch()" ref="search"><span>{{this.getLanguage['GL']['CONFIRM']}}</span></CButton>
                        </div>
                    </div>
                </div>

                <div class="sliding-div" :class="{ 'is-visible': slideindetail }" @click.stop>
                    <div class="position-relative h-100 overflow-auto">
                        <h2 class="text-white font-weight-bold" :class="obj_transaction.RS == 2 ? 'text-success' : (obj_transaction.RS == 3 ? 'text-danger' : 'text-warning')">{{ formatNumber(obj_transaction.TA, 2, obj_transaction.CS) }}</h2>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{getLanguage['MTA']['TID']}}</div>
                            <div class="sliding-item-desc">{{obj_transaction.AGTI}}</div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{getLanguage['GL']['DT']}} </div>
                            <div class="sliding-item-desc">
                                <template v-if="obj_transaction.CTS">
                                    {{obj_transaction.CTS | moment('DD MMM YYYY HH:mm:ss')}}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{getLanguage['MEM']['CWA']}} </div>
                            <div class="sliding-item-desc">{{obj_transaction.ABN }}</div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{getLanguage['MEM']['CKMS']}}</div>
                            <div class="sliding-item-desc" :class="obj_transaction.RS == 2 ? 'text-success' : (obj_transaction.RS == 3 ? 'text-danger' : '')">{{renderStatus(obj_transaction.RS) }}</div>
                        </div>

                        <div class="sliding-item" v-if="obj_transaction.RR">
                            <div class="sliding-item-title">{{this.getLanguage["MTA"]["RR"]}} </div>
                            <div class="sliding-item-desc">
                                <template v-for="item in constRejectReasonW" v-if="item.id == obj_transaction.RR">
                                    {{ item.label }}
                                </template>
                                <template v-if="!constRejectReasonW.some(item => item.id == obj_transaction.RR)">
                                    {{ obj_transaction.RR }}
                                </template>
                            </div>
                        </div>
                        <div class="slidlingbtn">
                            <CButton color="success" block @click="slideindetail = false">
                                {{this.getLanguage["BTN"]["CLO"]}}
                            </CButton>
                        </div>
                    </div>
                </div>

                <!--<div class='table-wrapper p-0' style="background: transparent;">
        <div class="custom-table-wrapper" id="tHead">
            <table class='custom-table afb-blue'>
                <thead>
                    <tr>
                        <th>{{this.getLanguage["GL"]["NO"]}}</th>
                        <th>{{this.getLanguage['GL']['TNO']}}</th>
                        <th>{{this.getLanguage['MEM']['CWA']}}</th>
                        <th class="tableCtnRight">{{this.getLanguage["TD"]["A"]}}</th>
                        <th>{{this.getLanguage["GL"]["DT"]}}</th>
                        <th>{{this.getLanguage["MEM"]["CKMS"]}}</th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="custom-table-wrapper" id="tBody">
            <table class='custom-table afb-blue'>
                <thead>
                    <tr>
                        <th>{{this.getLanguage["GL"]["NO"]}}</th>
                        <th>{{this.getLanguage['GL']['TNO']}}</th>
                        <th>{{this.getLanguage['MEM']['CWA']}}</th>
                        <th class="tableCtnRight">{{this.getLanguage["TD"]["A"]}}</th>
                        <th>{{this.getLanguage["GL"]["DT"]}}</th>
                        <th>{{this.getLanguage["MEM"]["CKMS"]}}</th>
                    </tr>
                </thead>
                <tbody>

                <td colspan="100%" v-if="arr_transactionreportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                <tr v-for="(data,index) in arr_transactionreportList">
                    <td>{{ index + 1 }}</td>
                    <td>{{data.AGTI}}</td>
                    <td>{{data.ABN}}</td>
                    <td class="tableCtnRight">{{ formatNumber(data.TA, 2, data.CS) }}</td>
                    <td>{{formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss")}}</td>
                    <td>{{renderStatus(data.RS)}}</td>
                </tr>

                </tbody>
            </table>
        </div>

        <footer style=" padding: 0.57rem 0rem;">
            <div class="pageBtn">
                <button @click="ctrPage(int_Page-1)">
                    <span class="arrowLeft"></span>
                </button>
                <input class="page-control"
                       v-model="int_Page"
                       type="number"
                       v-shortkey.avoid
                       @keypress.enter="ctrPage(int_Page)" />
                <span class="tableItemCount">/ {{int_TP}}</span>
                <button @click="ctrPage(int_Page+1)">
                    <span class="arrowRight"></span>
                </button>
            </div>
        </footer>
    </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required, requiredIf, decimal, minValue } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, consMetaRobot, constImgURClientId, constRejectReasonW, loadingFullScreen } from '@/modules/Constant.js'
    import axios from "axios";
    import moment from "moment";
    import Vue from 'vue'
    import VueHotkey from 'v-hotkey'
    import Axios from 'axios';
    import draggable from 'vuedraggable';
    import Editor from '@tinymce/tinymce-vue'
    import $ from 'jquery'

    //Vue.use(require('vue-shortkey'))
    Vue.use(VueHotkey)

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                obj_aw:
                {
                    AGI: null,
                    AI: null,
                    TM: 0,
                    TID: "",
                    BAI: null,
                    BNI: null,
                    AB: "",
                    ABA: "",
                    ABN: "",
                    PMT: null,
                    R: "",
                    RS: 2,
                    IMA: 1,
                    TT: 2,
                    PM: null,
                    RURL: "",
                    AC: 2,
                    DI: 0,
                    TA: "",
                    CWA: ""
                }, // add withdraw
                dd_crypto: [],
                dd_tm: [], // transaction type
                CurrencySymbol: "",
                ErrBAAmount: "",
                is_loaded: false,
                constAccessType: constAccessType,
                constRejectReasonW: constRejectReasonW,
                arr_transactionreportList: [],              
                searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                reportHeaders: [],
                hideBrand: false,
                showSubBrand: false,
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                slideinsearchfilter: false,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 0, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                ddSubAgentList: null,
                ddDefaultSubBrand: null,
                searchSubAgent: null,
                searchExcludeSubAgent: false,
                rtSubBrand: 0,
                dd_subagentgroup: [],//subagent group option,
                creditBalance: 0,
                exchangeRate: 0,
                obj_cryptoacc: {
                    I: 0,
                    MINW: 0,
                    MAXW: 0,
                    ER: 0
                },
                slideindetail: false,
                obj_transaction: {},
                walletColor: '',
            }
        },
        validations: {
            obj_aw: {
                ABN: { required },
                TA: {
                    required,
                    decimal,
                    minValueValue: minValue(0)
                },
                BAI: { required },
            }
        },

        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'MS';
            this.$parent.showActiveMenu = 'MS.S';
            this.curAGI = this.getUserInfo.AGI;
            this.hideBrand = this.getUserInfo.IHAGIF;
            this.getCryptoList(this.getUserInfo.AAGI);
            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
                this.getBalance();
                this.getTransactionReportList();

                if (this.$route.query.t) {
                    this.bool_isAMV = this.$route.query.t == 1 ? false : true;
                    this.bool_isAMV = this.$route.query.t == 2 ? true : false;
                }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            ...mapGetters('SMBData', [
                'getCurrencySymbol',
                'getSystemBalance',
                'getCreditBalance',
                'getBalanceStatus',
                'getCurrencyCode'
            ]),
        },
        methods: {
            selectSubAgentOptions(value, instanceId) {
                this.arr_breadcrum = [];
                this.searchAgi = 0;
                if (value) {
                    this.searchAgi = value;
                } else {
                    this.searchSubAgent = null;
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                            that.getTransactionReportList();
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },
            newsearch() {
                this.$refs.search.focus();
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getTransactionReportList();
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getMonthStartDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            renderStatus(int_status) {
                switch (int_status) {
                    case 2:
                        return this.getLanguage["GL"]["APRD"];
                        break;
                    case 3:
                        return this.getLanguage["GL"]["REJD"];
                        break;
                    default:
                        return this.getLanguage["GL"]["PEND"];
                        break;
                }
            },
            CryptoChange(value) {
                //var cryptoCode = "";
                if (value != undefined) {
                    for (var pt of this.dd_crypto) {
                        if (pt.id == value) {
                            //cryptoCode = pt.label;
                            if (pt.extra == "True") {
                                this.str_WithdrawalNote = this.getLanguage['CAL']['WN2'];
                            } else {
                                this.str_WithdrawalNote = this.getLanguage['CAL']['WN1'];
                            }
                            this.obj_cryptoacc.MINW = pt.minw;
                            this.obj_cryptoacc.MAXW = pt.maxw;
                            this.obj_cryptoacc.ER = 1;

                            this.obj_aw.AB = pt.label2;
                            this.obj_aw.BAI = pt.id;

                            //this.postDataApi(`/api/agtrans/cd/${pt.cc}/${pt.ci}/${this.getUserInfo.AAGI}`,
                            //    function (d, s) {
                            //        if (s) {
                            //            console.log(d.D);
                            //            //this.obj_cryptoacc.ER = d.D.
                            //        }
                            //    });

                            break;
                        }
                    }
                } else {
                    this.obj_aw.TA = null;
                }
            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {

                    if (langKey == "") {
                        langKey = value;
                    }

                    var validateObj = this.$v.obj_aw[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage["MTA"][langKey]);
                    }
                }

            },
            getCryptoList(value) {
                var that = this;
                var currencyId = this.getUserInfo.CID;
                //this.getDataApi(`/api/dd/cryptoextend/${value}/${currencyId}`,
                //this.getDataApi(`/api/dd/ggearncrypto/${value}/${currencyId}`,
                this.getDataApi(`/api/dd/crypto`,
                    function (d, s) {
                        if (s && d.dropdownlist && d.dropdownlist.length > 0) {
                            d.dropdownlist = _.sortBy(d.dropdownlist, ['label']);

                            d.dropdownlist.forEach((item) => {
                                // After sorting, check conditions and push to `dd_crypto`
                                if (item.s === 2 && item.ci === 8 && item.cryptologo) {
                                    item.label2 = item.label;
                                    item.label = `<img src="${item.cryptologo}" width="18" class="mr-2 img-fluid">${item.label}`;
                                    that.dd_crypto.push(item);
                                }
                            });
                        }
                    });
            },
            getBalance() {
                var sagi = 0;
                sagi = this.curAGI;
                var that = this;
                this.getDataApi(`/api/agtrans/gcb/` + sagi,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d.D) {
                            that.walletColor = (d.D.CBL < 0) ? 'text-danger' : 'text-success';

                            const decimalPlaces = that.CheckIsThousandCurrency(that.getCurrencySymbol) ? 3 : 2;
                            that.creditBalance = (d.D.CBL > 0) ? d.D.CBL.toFixed(decimalPlaces) : (0).toFixed(decimalPlaces);
                            that.exchangeRate = (d.D.ER > 0) ? d.D.ER.toFixed(decimalPlaces) : (0).toFixed(decimalPlaces);
                            that.CurrencySymbol = d.D.ISOC ? d.D.ISOC : "";
                        }
                    });
            },
            saveWithdraw() {
                this.bool_CV = true;
                this.ErrBAAmount = "";
                this.bool_fullLoading = true;

                this.obj_aw['TM'] = 2;
                var transAmount = 0;

                transAmount = parseFloat(this.obj_aw.TA);

                this.$v.obj_aw.$touch();
                if (!this.$v.obj_aw.$error) {
                    if (transAmount.toFixed(this.getThousandCurrency ? 3 : 2) != parseFloat(this.obj_aw.TA).toFixed(this.getThousandCurrency ? 3 : 2) && this.obj_aw.TM == 0) {
                        this.ErrBAAmount = this.getLanguage["MTA"]["ErrAmount"];
                        this.bool_fullLoading = false;
                    }
                    else {
                        this.obj_aw['PM'] = 7;
                        this.obj_aw['TT'] = "2";
                        this.obj_aw['AGI'] = this.getUserInfo.AAGI;
                        this.obj_aw['SAGI'] = this.curAGI;
                        this.obj_aw['ER'] = this.obj_cryptoacc.ER;
                        this.obj_aw['R'] = this.formatNumber(this.obj_aw.CWA, 9) + ' ' + this.obj_aw.AB + ' x ' + 'USD 1 x ' + this.CurrencySymbol + ' ' + parseFloat(this.exchangeRate).toFixed(this.getThousandCurrency ? 3 : 2);

                        //if (this.obj_aw['AGIT'] != null) {
                        //    var selectedAGI = 0;
                        //    var agiSelectedValue = this.obj_aw['AGIT'].id;
                        //    var agentList = agiSelectedValue.split("-");
                        //    if (agentList[0] == "4") {
                        //        selectedAGI = this.obj_aw['AGIT'].extra;
                        //    }
                        //    else {
                        //        selectedAGI = agentList[agentList.length - 1];
                        //    }

                        //    this.obj_aw.AGI = selectedAGI;
                        //}

                        var that = this;
                        this.bool_fullScreen = true;
                        this.postDataApi(`/api/agtrans/cw`, that.obj_aw,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    that.bool_CV = false;
                                    that.$fire({
                                        // type: 'error',
                                        //title: that.utilGetErrorLanguage("ERR.SS"),
                                        html: that.utilGetErrorLanguage("GL.AS"),
                                        width: '20em',
                                        keydownListenerCapture: true,
                                        iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                        customClass: {
                                            title: 'afb-alert-title text-success',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        },
                                        didOpen: () => {
                                            const confirmButton = document.querySelector('.afb-alert-action button');
                                            if (confirmButton) {
                                                confirmButton.focus();
                                            }
                                        }
                                    });
                                    that.getTransactionReportList();
                                } else {
                                    that.bool_CV = false;
                                    that.bool_isAMV = false
                                }
                            });
                    }
                } else {
                    this.bool_fullLoading = false;
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_aw"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            addWithdrawal() {
                var tempAGIT = this.obj_aw.AGIT;
                var tempAGI = this.obj_aw.AGI;
                this.obj_aw =
                {
                    AGIT: tempAGIT,
                    AGI: tempAGI,
                    AI: null,
                    TM: 0,
                    TID: "",
                    BAI: null,
                    BNI: null,
                    MB: "",
                    MBA: "",
                    MBN: "",
                    PMT: null,
                    R: "",
                    RS: 2,
                    IMA: 1,
                    TT: 2,
                    PM: null,
                    RURL: "",
                    AC: 2,
                    TA: "",
                };

                this.bool_isAMV = true;
            },
            getTransactionReportList() {
                this.is_loaded = true;
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(1, 50, "CTS", true);

                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.UTS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                        /*sessionStorage.setItem('TWLBMEM2_FilterSTS_from', this.parseDateToJsonString(this.searchCreatedTS.startDate));*/
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.UTS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                        //sessionStorage.setItem('TWLBMEM2_FilterSTS_to', this.parseDateToJsonString(this.searchCreatedTS.endDate));
                    }
                }

                if (path) {
                    path += "&";
                }

                path += (
                    "f.AGI=" + this.curAGI
                );
                this.getDataApi(`/api/agtrans/gt?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.slideinsearchfilter = false;
                            that.setWithdrawList(d.D);
                        }
                    });
            },
            setWithdrawList(data) {
                this.arr_transactionreportList = data.Items;
                this.int_TP = data.TotalPages;
                this.int_TI = data.TotalItems;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('ESW', 'AGS', type);
            },
            ctrPage(newPage) {
                this.int_Page = newPage;
                if (newPage > this.int_TP) {
                    this.int_Page = this.int_TP;
                }
                if (newPage <= 0) {//here set the limit of the label num
                    this.int_Page = 1;
                }
                this.int_IC = this.int_Page;
                this.getTransactionReportList();
            },
            newSearch() {
                if (!this.bool_isAMV && this.int_Page == this.int_IC) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getTransactionReportList();
                }
                if (!this.bool_isAMV && this.int_Page != this.int_IC) {
                    this.ctrPage(this.int_Page);
                }
            },
            getLangauge() {
                var that = this;
                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_langfs = d.dropdownlist
                        }
                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_as['AGIT'] && this.bool_isAMV) {
                    var agentList = this.obj_as['AGIT'].split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.str_FV[1].FV && !this.bool_isAMV) {
                    var agentList = this.str_FV[1].FV.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            setSortLogo(str_TF) {
                return `${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'active cil-sort-descending' : 'active cil-sort-ascending') : 'fa fa-sort'}`;//here change the sort logo
            },
            slideInMemberDetail(data) {
                this.slideindetail = true;
                this.obj_transaction = data;
            },
        },
        watch: {
            //bool_isAMV() {
            //    if (!this.bool_isAMV && this.bool_CV) {
            //        this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
            //    }
            //},
            'obj_aw.TA': function (newPT) {
                if (parseFloat(parseFloat(newPT).toFixed(4)) > parseFloat(parseFloat(this.creditBalance).toFixed(4))) {
                    this.obj_aw.TA = parseFloat(this.creditBalance).toFixed(this.getThousandCurrency ? 3 : 2);
                }
                this.obj_aw.CWA = this.formatNumber((this.obj_aw.TA / this.exchangeRate), 9);
            },
            getLanguage() {
                this.getTransactionReportList();
            },
            '$route.query': {
                handler(newQuery, oldQuery) {
                    this.bool_isAMV = this.$route.query.t == 1 ? false : true;
                    this.bool_isAMV = this.$route.query.t == 2 ? true : false;
                },
                immediate: true // Trigger watcher immediately when the component is created
            }
        },
    }
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/componentsGGEarn/SideMenu/WithdrawCredit.vue